module.exports = __webpack_public_path__ + "static/media/13-Ochoa(1).dd5ccbc0.png";